import { Session } from "../../models";

enum keys {
    TOKEN = "Fav_pwa_token",
    USER = "Fav_pwa_user",
}

// return the user data from the session storage
export const getUser = () => {
    const userStr = sessionStorage.getItem(keys.USER); //|| localStorage.getItem(keys.USER);
    if (userStr) return JSON.parse(userStr);
    else return null;
};

// return the token from the session storage
export const getToken = () => {
    return (
        sessionStorage.getItem(keys.TOKEN) ||
        //localStorage.getItem(keys.TOKEN) ||
        null
    );
};

// remove the token and user from the session storage
export const removeUserSession = () => {
    //localStorage.removeItem(keys.TOKEN);
    // localStorage.removeItem(keys.USER);

    sessionStorage.removeItem(keys.TOKEN);
    sessionStorage.removeItem(keys.USER);
};

// set the token and user from the session storage
export const setUserSession = (token: string, user: Session) => {
    //localStorage.setItem(keys.TOKEN, token);
    // localStorage.setItem(keys.USER, JSON.stringify(user));

    sessionStorage.setItem(keys.TOKEN, token);
    sessionStorage.setItem(keys.USER, JSON.stringify(user));
};
